import React from 'react';
import {
  TEAM_SETUP_AREAS_UPDATED,
  TeamSetupArea,
  useAuthenticationContext,
  useTeamSetupAreasService
} from 'nekst-api';
import { useDataLoaderNew } from 'data-loader';
import { LoadingAnimation } from 'ui-builder';

type TeamMarketsContextType = {
  teamSetupAreas: TeamSetupArea[],
  loading: boolean,
}
const TeamSetupAreasReactContext = React.createContext<TeamMarketsContextType | undefined>(undefined);

export function useTeamSetupAreasContextRequired(): TeamMarketsContextType {
  const context = React.useContext(TeamSetupAreasReactContext);
  if (!context) {
    throw new Error('useTeamSetupAreasContext must be used within a TeamSetupAreasContext');
  }

  return context;
}

export function TeamSetupAreasContext(props: {
  children: React.ReactNode,
}) {
  const teamSetupAreasService = useTeamSetupAreasService();

  const authenticationContext = useAuthenticationContext();

  const {
    data: teamSetupAreas,
    loading
  } = useDataLoaderNew(
    async () => {
      if (authenticationContext?.user) {
        return teamSetupAreasService.getTeamSetupAreas();
      } else {
        return undefined;
      }
    },
    {
      events: [TEAM_SETUP_AREAS_UPDATED],
      dependencies: [authenticationContext?.user.id]
    }
  );

  if (authenticationContext?.user) {
    if (teamSetupAreas) {
      return (
        <TeamSetupAreasReactContext.Provider
          value={{
            teamSetupAreas: teamSetupAreas || undefined,
            loading: loading
          }}
        >
          {props.children}
        </TeamSetupAreasReactContext.Provider>
      );
    } else {
      return (<LoadingAnimation />);
    }
  } else {
    return props.children;
  }
}
